import React from 'react';
import { MobileSocialLinks } from '../../atoms/navbar-atoms/mobile-social-links/mobile-social-links';
import { MobileMenuLanguageButton } from '../../atoms/navbar-atoms/mobile-menu-language-button/mobile-menu-language-button';
import { NavbarColumns } from '../navbar-columns/navbar-columns';
import {
  ChevronLeftAtom,
  MobileCloseIcon,
} from '../../atoms/icon-atoms/nav-icon-atoms';
import {
  Align,
  BackCopy,
  Heading,
  IconWrapper,
  SecondaryWrapper,
  SecondaryWrapperNav,
} from './mobile-menu-second-level.styles';

export const MobileMenuSecondLevel = ({
  handleBackClick,
  handleReset,
  tabs,
  columnData,
  languages,
  isLanguagesOpen,
  selectedTab,
}) => {
  return (
    <>
      <SecondaryWrapper
        key={'second-level-nav-top'}
        initial={{
          x: '100%',
        }}
        animate={{ x: '0%' }}
        transition={{ duration: 0.2 }}
        exit={{ x: '100%' }}
      >
        <SecondaryWrapperNav>
          <Align onClick={handleBackClick}>
            <ChevronLeftAtom />
            <BackCopy>Back</BackCopy>
          </Align>
          <IconWrapper data-testid="close-icon" onClick={handleReset}>
            <MobileCloseIcon />
          </IconWrapper>
        </SecondaryWrapperNav>

        {selectedTab && (
          <>
            <Heading data-testid="secondary-level-heading">
              {tabs.find(tab => tab.contentful_id === selectedTab)?.title}
            </Heading>
            <NavbarColumns data={columnData} />;
          </>
        )}
        {isLanguagesOpen && (
          <>
            <Heading>Choose Language</Heading>
            {languages.map(language => (
              <MobileMenuLanguageButton
                key={language.abbreviation}
                language={language}
              />
            ))}
          </>
        )}
      </SecondaryWrapper>
      <MobileSocialLinks withAnimation={false} />
    </>
  );
};
